<template>
  <el-dialog title="选择商品" :visible.sync="dialogVisible" width="1200px" @close="handleClose">
    <div class="table-searchs">
      <div class="table-search-item" v-for="searchItem in searchList" :key="searchItem.prop" :class="'search-' + searchItem.prop">
        <component
          :is="'search-' + searchItem.type"
          :propKey="searchItem.prop"
          :items="searchItem.items"
          v-model="searchForm[searchItem.prop]"
          @search="search"
          @setQueryParams="setSearchForm"
          :attrs="searchItem.attrs"
          :style="searchItem.style"
          v-bind="searchItem.extraBind || {}"
        />
      </div>
      <div class="table-search-item">
        <el-button @click="search" type="primary">查询</el-button>
      </div>
      <div class="table-search-item">
        <el-button @click="clear">清空</el-button>
      </div>
    </div>
    <div>
      <el-table-grid
        class="item-table"
        ref="table"
        :data="list"
        border
        max-height="500px"
        tooltip-effect="dark"
        :stripe="false"
        @selection-change="onSelectionChange"
      >
        <el-table-column align="center" type="selection" width="55" />
        <el-table-column width="50" type="index" :index="indexMethod" />
        <el-table-column
          v-for="(col, cindex) in tableCols"
          :key="col.prop + cindex"
          :prop="col.prop"
          :resizable="resizable"
          v-bind="col.attrs"
          :min-width="col.attrs.width"
        >
          <!-- 图片列 -->
          <template v-if="col.prop === 'mainImages'" v-slot="{ row }">
            <div class="img-cell">
              <ListLazyImg :src="row.mainImages[0]" :isDistribution="row.isDistribution" />
            </div>
          </template>
          <!-- 销售价 -->
          <template v-else-if="col.prop === 'salesPrice'" v-slot="{ row }">
            {{ renderPrice(row, 'salesPrice', 'maxSalesPrice', 'salesPrice') }}
          </template>
          <!-- 成本价 -->
          <template v-else-if="col.prop === 'purchasePrice'" v-slot="{ row }">
            {{ renderPrice(row, 'purchasePrice', 'maxPurchasePrice', 'purchasePrice') }}
          </template>
          <!-- 供货价 -->
          <template v-else-if="col.prop === 'supplyPrice'" v-slot="{ row }">
            {{ renderPrice(row, 'minSupplierPrice', 'maxSupplierPrice', 'supplyPrice') }}
          </template>
        </el-table-column>
        <template slot="empty">
          <span>暂无数据</span>
        </template>
      </el-table-grid>
    </div>
    <el-pagination
      class="pagination"
      @size-change="onPageSizeChange"
      @current-change="onPageChange"
      :current-page="pagination.pageNo"
      :page-sizes="morePage ? [10, 20, 50, 100, 200, 500] : [10, 20, 50, 100]"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
    />
    <span slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleOk">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import SearchInput from '@components/prod/center/components/SearchInput.vue';
import ListLazyImg from '@/components/ListLazyImg/index.vue';
import { getGoodsList } from '@/servers/prod/center';

export default {
  name: 'SelectProdDialog',
  components: {
    SearchInput,
    ListLazyImg,
  },
  data() {
    return {
      dialogVisible: false,
      opts: {},
      pagination: {
        pageNo: 1,
        pageSize: 20,
        total: 0,
      },
      searchForm: {
        outerIds: '',
        skuOuterIds: '',
        title: '',
      },
      searchList: [
        { prop: 'outerIds', type: 'input', attrs: { placeholder: '多个款式编码，以英文逗号分割', label: '款式编码', isDialog: true } },
        { prop: 'skuOuterIds', type: 'input', attrs: { placeholder: '多个商品编码，以英文逗号分割', label: '商品编码', isDialog: true } },
        { prop: 'title', type: 'input', attrs: { placeholder: '商品名称' } },
      ],
      tableCols: [
        { prop: 'mainImages', attrs: { label: '图片', width: '90px' }, slot: true },
        { prop: 'outerId', attrs: { label: '款式编码', width: '260px', 'class-name': 'outerId-cell', 'show-overflow-tooltip': true } },
        { prop: 'skuOuterId', attrs: { label: '商品编码', width: '90px' } },
        { prop: 'title', attrs: { label: '商品名称', width: '180px', 'show-overflow-tooltip': true } },
        { prop: 'salesPrice', attrs: { label: '销售价' }, slot: true },
        { prop: 'purchasePrice', attrs: { label: '成本价' }, slot: true },
        { prop: 'supplierPrice', attrs: { label: '供货价' }, slot: true },
      ],
      list: [],
      selectedArr: [],
      morePage: false, // 如有需要可动态控制
      resizable: true, // 如有需要可动态控制
    };
  },
  methods: {
    method_open(opts) {
      this.opts = opts;
      this.dialogVisible = true;
      this.fetchList();
    },
    onSelectionChange(val) {
      this.selectedArr = val;
    },
    indexMethod(index) {
      return (this.pagination.pageNo - 1) * this.pagination.pageSize + index + 1;
    },
    onPageSizeChange(val) {
      this.pagination.pageNo = 1;
      this.pagination.pageSize = val;
      this.fetchList();
    },
    onPageChange(val) {
      this.pagination.pageNo = val;
      this.fetchList();
    },
    async fetchList() {
      const { pageNo, pageSize } = this.pagination;
      const params = {
        pageNo,
        pageSize,
        ...this.searchForm,
      };
      const res = await getGoodsList(params);
      if (!res) return;
      const { records, total } = res;
      this.list = records;
      this.pagination.total = total;
    },
    search() {
      this.pagination.pageNo = 1;
      this.fetchList();
    },
    clear() {
      this.searchForm = {
        outerIds: '',
        skuOuterIds: '',
        title: '',
      };
      this.search();
    },
    handleClose() {
      Object.assign(this.$data, this.$options.data());
    },
    handleOk() {
      if (!this.selectedArr.length) {
        return this.$message.warning('请选择商品！');
      }
      this.opts.okFn && this.opts.okFn(this.selectedArr);
      this.handleClose();
    },
    setSearchForm(val) {
      // 若有 setQueryParams 事件需求可补充
      Object.assign(this.searchForm, val);
    },
    renderPrice(row, minKey, maxKey, singleKey) {
      if (row[maxKey] !== undefined) {
        return `${row[minKey]} ~ ${row[maxKey]}`;
      }
      return row[singleKey];
    },
  },
};
</script>

<style lang="scss" scoped>
.table-searchs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
  .table-search-item {
  }
}
.item-table {
  margin-bottom: 12px;
}
.img-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}
.pagination {
  padding: 8px 16px;
  text-align: right;
}
</style>
